module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/brand_logos-5cdedb619ff764a2f79084f9729a9a35.png";